import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import requestTool from "../../tools/requestTool";
import "../LoadingPanel";

export const FieldCalculate = (props) => {
    const { t } = useTranslation();
    const [calculateData, setCalculateData] = useState({});
    const [values, setValues] = useState([]);
    const groupColumns = [
        { name: "gelen", value: true },
        { name: "giden", value: true }
    ];

    const groupBy = (array, key) => {
        return array.reduce((result, currentItem) => {
            const group = currentItem[key];
            if (!result[group]) {
                result[group] = [];
            }
            result[group].push(currentItem);
            return result;
        }, {});
    };

    useEffect(() => {
        getTableDetailSummarize(props.tableId, props.layerId, props.wkt, 'Total');
    }, []);

    const showLoading = (state) => {
        props.loadingAction && props.loadingAction.setIsLoading(state);
    };

    const getTableDetailSummarize = (tableId, layerId, wkt, dateTypeFilter) => {
        showLoading(true);
        if (props.feature) {
            wkt = props.MapTool.convertToWkt(props.feature, "EPSG:4326", "EPSG:3857");
        }

        requestTool.postRequest(`${props.apiUrl}/Analysis/CalculateArea/CalculateArea`, {
            wkt,
            tableId,
            layerId,
            groupColumns,
            dateFilterType: dateTypeFilter,
            values
        }).then(res => {
            showLoading(false);
            if (res.success && res.data) {
                const groupedItems = groupBy(res.data, 'groupName');
                setCalculateData(groupedItems);
            } else {
                showLoading(false);
                props.onHide();
            }
        }).catch(() => {
            showLoading(false);
        });
    };

    return (
        <Dialog
            header={props.header}
            visible={Object.keys(calculateData).length > 0}
            onHide={props.onHide}
        >
            <div className="card flex gap-3">
                <Button
                    label={t('FieldCalculate.total')}
                    severity="secondary"
                    onClick={() => getTableDetailSummarize(props.tableId, props.layerId, props.wkt, 'Total')}
                />
                <Button
                    label={t('FieldCalculate.monthly')}
                    severity="secondary"
                    onClick={() => getTableDetailSummarize(props.tableId, props.layerId, props.wkt, 'Month')}
                />
                <Button
                    label={t('FieldCalculate.threeMonthAverage')}
                    severity="secondary"
                    onClick={() => getTableDetailSummarize(props.tableId, props.layerId, props.wkt, '3MonthAvarage')}
                />
                <Button
                    label={t('FieldCalculate.oneMonthDailyAverage')}
                    severity="secondary"
                    onClick={() => { /* TODO: Implement if needed */ }}
                />
            </div>

            <Divider />

            <div style={{ display: "flex" }}>
                {Object.keys(calculateData).map((category, i) => (
                    <div key={category} style={{ flex: 1, marginLeft: "0px 10px" }}>
                        <table style={tableStyle}>
                            <thead>
                                <tr>
                                    <th colSpan="2" style={cellStyle}>{category}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {calculateData[category].map((item) => (
                                    <tr key={item.id}>
                                        {i < 1 && <td style={cellStyle}>{i === 0 ? item.columnName : ""}</td>}
                                        <td style={cellStyle}>{item.value}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ))}
            </div>
        </Dialog>
    );
};

const tableStyle = {
    width: "100%",
    margin: "0 auto",
    borderCollapse: "collapse",
    fontFamily: "Arial, sans-serif",
    marginLeft: "0px"
};

const cellStyle = {
    border: "1px solid #ccc",
    padding: "8px"
};

export default FieldCalculate;
